// The closed lists on a time-off row (migration 025), and what each is called on screen.
//
// Here rather than under server/ for the reason provinces.js is: the server validates the
// value, the dialogs offer the choice, Claude's tools describe it, and two hand-kept copies of
// a list is one copy plus a latent bug. No imports and no I/O. The keys are stored; the labels
// are only captions and can be reworded freely. Keep the keys in step with the CHECKs in
// migrations/025_time_off_private.sql.

export const TIME_OFF_REASONS = [
  { key: 'vacation', label: 'Vacation' },
  { key: 'sick', label: 'Sick' },
  { key: 'absent', label: 'Absent' },
  { key: 'no_show', label: 'No-show' },
  { key: 'other', label: 'Other' },
]

// Whether the formal request for the time off has gone in. No value at all means nobody is
// tracking it, which is the default.
// `short` is for a control already labelled "Time-off request", where repeating the word is
// noise; `label` stands on its own, in a tooltip or a sentence.
export const REQUEST_STATUSES = [
  { key: 'awaiting', label: 'Request not yet submitted', short: 'Not yet submitted' },
  { key: 'submitted', label: 'Request submitted', short: 'Submitted' },
  { key: 'approved', label: 'Request approved', short: 'Approved' },
]

export const isTimeOffReason = (v) => TIME_OFF_REASONS.some((r) => r.key === v)
export const isRequestStatus = (v) => REQUEST_STATUSES.some((r) => r.key === v)

export const reasonLabel = (key) => TIME_OFF_REASONS.find((r) => r.key === key)?.label || null
export const requestLabel = (key) => REQUEST_STATUSES.find((r) => r.key === key)?.label || null
